export const slotGameMenuData = [
    { titleKey: 'lbl_SlotGame_SabaCasino', vdid: 10 },
    { titleKey: 'lbl_SlotGame_PragmaticPlay', vdid: 32 },
    { titleKey: 'lbl_SlotGame_PGSoft', vdid: 55 },
    { titleKey: 'lbl_SlotGame_Habanero', vdid: 61 },
    { titleKey: 'lbl_SlotGame_Voidbridge', vdid: 12 },
    { titleKey: 'lbl_SlotGame_Spadegaming', vdid: 36 },
    { titleKey: 'lbl_SlotGame_CG', vdid: 62 },
    { titleKey: 'lbl_SlotGame_Joker', vdid: 56 },
    { titleKey: 'lbl_SlotGame_Jili', vdid: 75 },
    { titleKey: 'lbl_SlotGame_Microgaming', vdid: 73 },
    
];